// Registr grafických skinů. Skin se volí per liga (League.skinId) a aplikuje se na
// celé on-air vysílání přepnutím CSS třídy na #layer-container (viz broadcast-layer).
export type SkinId = 'default' | 'EC23' | 'ODM';

export interface SkinDef {
  id: SkinId;
  name: string;
  // CSS třída nasazená na kořenový kontejner; prázdná = výchozí vzhled.
  cssClass: string;
  // ODM norma: ve vysílací grafice se loga týmů nepoužívají, jen 3písmenné kódy.
  hideTeamLogos: boolean;
}

export const SKINS: SkinDef[] = [
  {id: 'default', name: 'Výchozí', cssClass: '', hideTeamLogos: false},
  {id: 'EC23', name: 'EC23', cssClass: 'skin-ec23', hideTeamLogos: false},
  {id: 'ODM', name: 'ODM', cssClass: 'skin-odm', hideTeamLogos: true},
];

export const DEFAULT_SKIN: SkinDef = SKINS[0];

export function getSkinById(skinId?: string): SkinDef | undefined {
  return SKINS.find(s => s.id === skinId);
}
